import { IItem } from "./PopOverMenu";
import "./style/PopOverMenuItem.scss";

export const PopOverMenuItem = ({ icon: Icon, title, onClick, disabled }: IItem) => {
  const titleClass = `PopOverMenuItem-Title ${disabled ? "disabled" : ""}`;

  return (
    <button className="PopOverMenuItem" onClick={onClick} disabled={disabled} aria-label={title}>
      <div className="PopOverMenuItem-Img">
        <Icon />
      </div>
      <span className={titleClass}>{title}</span>
    </button>
  );
};
